<script setup lang="ts">
import { ref } from 'vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { TrashIcon } from '@heroicons/vue/24/outline'

interface Props {
  deleteText?: string
  confirmText?: string
  cancelText?: string
  variant?: 'error' | 'primary' | 'secondary' | 'accent'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  loading?: boolean
}

withDefaults(defineProps<Props>(), {
  deleteText: 'Supprimer',
  confirmText: 'Supprimer définitivement',
  cancelText: 'Annuler',
  variant: 'error',
  size: 'sm',
  loading: false,
})

const emit = defineEmits<{
  delete: []
  cancel: []
}>()

const showConfirmation = ref(false)

const openConfirmation = () => {
  showConfirmation.value = true
  emit('cancel')
}

const closeConfirmation = () => {
  showConfirmation.value = false
  emit('cancel')
}

const handleDelete = () => {
  emit('delete')
}

defineExpose({
  reset: closeConfirmation,
})
</script>

<template>
  <div class="flex items-center gap-4">
    <div class="flex items-center gap-4">
      <button-daisy
        v-if="!showConfirmation"
        @click="openConfirmation"
        :text="deleteText"
        :variant="variant"
        :size="size"
        :icon="TrashIcon"
        type="button"
      />
      <div v-else class="flex items-center gap-4">
        <button-daisy
          @click="handleDelete"
          :text="confirmText"
          :variant="variant"
          :size="size"
          :loader="loading"
          type="button"
        />
        <button-daisy
          @click="closeConfirmation"
          :text="cancelText"
          variant="primary"
          :size="size"
          type="button"
        />
      </div>
    </div>
    <slot v-if="!showConfirmation" />
  </div>
</template>
